/**
 * Standard props that ALL migrated widgets receive.
 * This is the ONLY interface between FieldResolver and migrated widgets.
 * No widget should ever access $attrs, $parent, inject, or any other mechanism.
 *
 * If this list grows large, that's a signal of design issues — props that are
 * only relevant to one widget type should come from widgetArgs (server metadata)
 * rather than being passed through the caller → FieldResolver → widget chain.
 */
export const STANDARD_FIELD_PROPS = {
  // --- Data ---
  value: { default: undefined },
  fieldMeta: { type: Object, default: () => ({}) },
  widgetArgs: { type: Object, default: () => ({}) },

  // --- Identity ---
  fieldId: { type: String, default: '' },

  // --- State ---
  editable: { type: Boolean, default: false },

  // --- Validation ---
  validationRules: { type: Array, default: () => [] },
  validationScope: { type: String, default: undefined },
  errorMessage: { type: String, default: undefined },
  hasError: { type: Boolean, default: false },

  // --- Cross-field ---
  dependencies: { type: Object, default: () => ({}) },
}

/**
 * Declares which record fields a widget needs access to.
 * propBuilder extracts ONLY these fields from `record` into `dependencies`.
 * Widgets access them as `props.dependencies.fieldName.value`.
 */
export const WIDGET_DEPENDENCIES = {
  AutoIncrement: ['owned_by'],
}
